import { FC } from 'react'
import cx from 'classnames'
import { useTheme } from 'styled-components'

import { LinkProps } from '../Link'

import * as SC from './styled'

export type PaginationProps = {
  className?: string
  items: Array<LinkProps & { current: boolean }>
}

const Pagination: FC<PaginationProps> = ({ className, items }) => {
  const theme = useTheme()
  const numberOfPages = items.length
  const currentIndex = items.findIndex((i) => i.current)
  const next = items?.[currentIndex + 1]
  const previous = items?.[currentIndex - 1]

  const renderDefault = () => {
    return items.map((p, idx) => (
      <SC.Item key={idx} {...p} $active={p.current} />
    ))
  }

  const renderComplex = () => {
    const difference = numberOfPages - 1 - currentIndex
    const isAfter = difference <= 1

    const before = isAfter
      ? [items[0]]
      : currentIndex > 1
      ? items.slice(currentIndex - 2, currentIndex + 2)
      : items.slice(0, currentIndex + 2)

    const last = !isAfter
      ? [items[numberOfPages - 1]]
      : currentIndex === numberOfPages - 1
      ? items.slice(currentIndex - 2, currentIndex + 1)
      : items.slice(currentIndex - 2, currentIndex + 2)

    return (
      <>
        {before.map((p, idx) => (
          <SC.Item key={idx} {...p} $active={p.current} />
        ))}
        {`...`}
        {last.map((p, idx) => (
          <SC.Item key={idx} {...p} $active={p.current} />
        ))}
      </>
    )
  }

  return (
    <SC.Pagination className={cx('Pagination', className)}>
      {previous && (
        <SC.Item {...previous}>
          <SC.Arrow
            icon="chevronLeft"
            width={14}
            height={14}
            color={theme.colors.pinkPrimary}
          />
        </SC.Item>
      )}
      {numberOfPages > 5 ? renderComplex() : renderDefault()}
      {next && (
        <SC.Item {...next}>
          <SC.Arrow
            icon="chevronRight"
            width={14}
            height={14}
            color={theme.colors.pinkPrimary}
          />
        </SC.Item>
      )}
    </SC.Pagination>
  )
}

export default Pagination
